<template>
  <div class="add-configuration-section">
    <a @click.prevent="toggleConfiguration"
       :class="['add-config-dropdown', {['is-open']: openAddConfiguration}]">
      <b>{{openAddConfiguration ? '-' : '+'}} add configuration</b>
    </a>
    <div v-if="openAddConfiguration" class="add-configuration-selections">
      <slot name="configItems"></slot>
    </div>
  </div>
</template>


<script>

  export default {
    props: {
      shouldOpenOnCreate: Boolean,
    },

    name: 'AddConfiguration',

    components: {
    },

    data() {
      return {
        openAddConfiguration: false,
      }
    },

    methods: {

      toggleConfiguration(event) {
        event.stopPropagation()
        this.openAddConfiguration = !this.openAddConfiguration
      },
    },

    created() {
      this.openAddConfiguration = this.shouldOpenOnCreate
    },
  }
</script>
